import React from "react";
import "./NavegacaoConteudo.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function NavegacaoConteudoLoadingSkeleton() {
  return (
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div className="large-only">
          <Skeleton width={120} height={40} inline={true} />
          <Skeleton width={90} height={40} inline={true} style={{marginLeft: 20}} />
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 navegacao-conteudo-main">
        <div className="mt-4 do-cards-area">
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
          <Skeleton
            width={155}
            height={200}
            inline={true}
            className="skeleton-dou-card"
          />
        </div>
      </div>
    </div>
  );
}

export default NavegacaoConteudoLoadingSkeleton;
